import { IconProps } from '@/root/shared-types/ui/ui-types'
import { FC } from 'react'
import Icon from '@/root/ui/shared/Icon'

export const WarningIcon: FC<IconProps> = ({ width = 35, height = 25, ...rest }) => (
  <Icon type="Warning" width={width} height={height} alt="WarningIcon" {...rest} />
)
